import React from 'react';
import { useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Box, styled } from '@mui/material';

import { Avatar } from 'Common/UserAvatar/Avatar';
import { AvatarUtils } from 'Common/UserAvatar/Avatar/Avatar.utils';
import { Colors } from 'Themes/colors';

import { formFieldNames } from './formFieldNames';

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  gap: 10px;
  height: 250px;
`;

const Option = styled(Box)`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;

const AvatarContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 33px;
  height: 33px;
`;

type Props = {
  displayName: string;
  onColorClick: (value: string) => void;
};

export const ColorPicker = ({ displayName, onColorClick }: Readonly<Props>) => {
  const { t } = useTranslation();

  const initial = AvatarUtils.getAvatarInitials(displayName);

  const selectedColor = useWatch({ name: formFieldNames.avatarColor });

  const handleColorClick = (id: string) => onColorClick(id);

  const colorDropdownOptions = Colors.availableUsersAvatarsColors
    .map(x => ({
      value: x.value,
      label: t(`myAccount.colors.${x.translationKey}`)
    }))
    .map(option => {
      const isSelected = selectedColor === option.value;

      return (
        <>
          <Option key={option.value} onClick={() => handleColorClick(option.value)}>
            <AvatarContainer>
              <Avatar
                color={option.value}
                displayName={isSelected ? (initial ?? '') : ''}
                shouldBiggerOnHover
              />
            </AvatarContainer>

            {option.label}
          </Option>
        </>
      );
    });

  return <Container>{colorDropdownOptions}</Container>;
};
